module.exports = __webpack_public_path__ + "static/img/home_product_00_zh-2.827d67b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_product_00_zh-2.png
// module id = XIaB
// module chunks = 34